'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { Suspense, useEffect } from 'react'

import { Button } from '@/lib/ui-kit/components/ui/Button.component'

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (options: {
          region: string
          portalId: string
          formId: string
          target: string
        }) => void
      }
    }
  }
}

const formIdMap = {
  contact: '2afcb506-e242-4fbd-8c76-61904400d8e1',
  partnership: '7e69a03a-7046-4deb-a71e-574e2d8c2db7',
}

export const FormContact = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const selectedForm = searchParams.get('form')

  const formId =
    formIdMap[selectedForm as keyof typeof formIdMap] || formIdMap.contact

  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '7759219',
          formId,
          target: '#formContact',
        })
      }
    })

    return () => {
      document.body.removeChild(script)
    }
  }, [formId, selectedForm])

  const setSelectedForm = (form: string) => {
    router.push(`?form=${form}`, { scroll: false })
  }

  return (
    <div className="flex flex-col">
      <div className="paragraph-xs mb-4">What are you looking for</div>

      <div>
        <Button
          variant={selectedForm === 'contact' ? 'primary' : 'secondary'}
          className="mr-2 rounded-full px-6"
          size="lg"
          onClick={() => setSelectedForm('contact')}
        >
          General Inquiry
        </Button>
        <Button
          variant={selectedForm === 'partnership' ? 'primary' : 'secondary'}
          className="mr-2 rounded-full px-6"
          size="lg"
          onClick={() => setSelectedForm('partnership')}
        >
          Partnership Inquiry
        </Button>
      </div>

      {selectedForm && (
        <div
          id="formContact"
          className={`formContact mt-10 xl:mt-16 ${
            selectedForm ? '' : 'opacity-50'
          }`}
        ></div>
      )}
    </div>
  )
}

export const SuspendedFormContact = () => {
  return (
    <Suspense>
      <FormContact />
    </Suspense>
  )
}
